import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ROUTES, USER_TYPE } from "./constants";
import { BuyerRoleGuardService } from "./services/buyer-role-guard.service";
import { SignupGuardService } from "./services/signup-guard.service";
import { SupplierRoleGuardService } from "./services/supplier-role-guard.service";
import { RouteDeactivateGuardService } from "./services/route-deactivate-guard.service";

const routes: Routes = [
	{
		path: ROUTES.AUTH,
		loadChildren: () => import("./pages/auth/auth.module").then((module) => module.AuthModule),
		canActivate: [SignupGuardService]
	},
	{
		path: ROUTES.BUYER,
		loadChildren: () => import("./pages/buyer/buyer.module").then((module) => module.BuyerModule),
		canActivate: [BuyerRoleGuardService],
		data: {
			allowedRole: USER_TYPE.BUYER
		}
	},
	{
		path: ROUTES.SUPPLIER,
		loadChildren: () => import("./pages/supplier/supplier.module").then((module) => module.SupplierModule),
		canActivate: [SupplierRoleGuardService],
		data: {
			allowedRole: USER_TYPE.SUPPLIER
		}
	},
	{
		path: ROUTES.PUBLIC,
		loadChildren: () => import("./pages/public/public.module").then(module => module.PublicModule)
	},
	{
		path: ROUTES.WILDCARD,
		redirectTo: ROUTES.LOG_IN
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { enableTracing: false })],
	exports: [RouterModule],
	providers: [RouteDeactivateGuardService]
})

export class AppRoutingModule { }
